import React from 'react'
import ApiClient from '../helpers/ApiClient';
import axios from 'axios';

export const addIntake = async ({ alumniIntake,degreeProgram }) => {
  try {
      const response = await ApiClient.post(`/AlumniPage/addAlumniIntake`, { alumniIntake,degreeProgram});
      console.log("Response:", response);
      return response;
  } catch (error) {
      console.error("API Error:", error);
      throw error;
  }
};

export const getIntakes = async ({ page, page_size }) => {  // Receive page and page_size
  try {
      const response = await ApiClient.get(`/AlumniPage/getAlumniIntake?page=${page}&page_size=${page_size}`); // Append to the URL
      console.log("response", response);
      return response;
  } catch (error) {
      throw error;
  }
}

export const updateIntake = async ({ id, alumniIntake, degreeProgram}) => {
  try {
    const response = await ApiClient.put(
      `/AlumniPage/updateAlumniIntake/${id}`,{ alumniIntake, degreeProgram });
    console.log("response", response);
    return response;
  } catch (error) {
    throw error;
  }
};

  export const deleteIntake = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/AlumniPage/deleteAlumniIntake/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}